export enum OneTrustCookieGroup {
  StrictlyNecessary = "C0001", // always enabled
  Analytical = "C0002", // tracking and site performance analysis
  Functional = "C0003", // e.g product videos, reviews, order place
  Targeting = "C0004", // advertising and recommendations
  SocialMedia = "C0005", // social media ads e.g youtube
}
